import {
  FaGithub,
  FaLinkedin,
  FaEnvelope,
  FaMapMarkerAlt,
  FaAngleRight,
  FaAngleLeft,
  FaExternalLinkAlt,
} from "react-icons/fa";
import { useReducer, useRef, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { motion, useInView, useAnimation } from "framer-motion";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import art from "../../componets/assets/images/art.png";
import validator from "../../componets/assets/images/validator.png";
import todo from "../../componets/assets/images/todo.png";
import stokveel from "../../componets/assets/images/stokveel.png";
import homeBg from "../assets/images/imprd.png";
import mandla from "../assets/images/mandla.png";
import reiq from "../assets/images/r5.jpg";
import { Link } from "react-router-dom";

const reducer = (state, action) => {
  switch (action.type) {
    case "hover":
      return { ...state, [action.id]: true };
    case "unhover":
      return { ...state, [action.id]: false };
    case "blog":
      return { ...state, [action.id]: true };
    default:
      return state;
  }
};

export default function Home() {
  const [hovered, dispatch] = useReducer(reducer, {
    link: false,
    blog: false,
  });

  const links = [{ id: "blog", to: "/blog", text: "Blog" }];

  const ref = useRef(null);
  const swiperRef = useRef(null);

  const [activeBackground, setActiveBackground] = useState(todo);

  const slides = [todo, validator, stokveel, reiq, art];
  const slide_delay = 3000;

  return (
    <div
      className="h-full w-full flex p-4 md:p-0"
      style={{
        backgroundImage: `url(${homeBg})`,
        backgroundSize: "cover",
        backgroundPosition: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="block pb-5 pt-3 md:pt-0 md:grid md:grid-cols-3 w-full m-auto md:gap-14 z-20 ">
        <div ref={ref} className="grid  md:gap-20 md:px-7 ">
          {/* *get in touch section */}

          <div className="hidden items-center justify-center md:flex  w-full  relative">
            <div className="animate-spinBorder flex justify-center items-center w-28 h-28 shadow-lg rounded-full border-2 border-dashed border-[#080808]"></div>
            {links.map((link) => (
              <Link
                key={link.id}
                to={link.to}
                className="z-10 absolute cursor-pointer w-20 h-20 rounded-full border border-[#053121] bg-[#978b72] flex items-center justify-center hover:bg-black hover:border-white hover:border-2 transition-all duration-1000 ease-out"
              >
                <p>Blog </p>
              </Link>
            ))}
          </div>
          <div className="px-0 md:px-8 flex flex-col justify-center ">
            <div className="py-10 bg-[#f9eaca] border border-gray-900 rounded-md ">
              <div className="flex items-center justify-center md:hidden  w-full">
                <div className="animate-spinBorder flex justify-center items-center w-28 h-28 shadow-lg rounded-full border-2 border-dashed border-[#080808]"></div>
                {links.map((link) => (
                  <Link
                    key={link.id}
                    to={link.to}
                    className="z-10 absolute cursor-pointer w-20 h-20 rounded-full border border-[#053121] bg-[#978b72] flex items-center justify-center hover:bg-black hover:border-white hover:border-2 transition-all duration-1000 ease-out"
                  >
                    <p>Blog </p>
                  </Link>
                ))}
              </div>
              <div className="relative  hidden items-center md:flex justify-center ">
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{
                    opacity: 1,
                    transition: {
                      duration: 0.4,
                      delay: 1.2,
                      ease: "easeInOut",
                    },
                  }}
                  className="flex rounded-lg items-center justify-center"
                >
                  <img
                    src={mandla}
                    alt=""
                    className="w-32 h-32 rounded-md  object-cover object-center"
                  />
                </motion.div>
              </div>
              <div className="flex mt-8 flex-col gap-2 items-center">
                <h1 className="text-[#326b43] font-medium">Mandla Mbolekwa</h1>
                <div className="bg-[#b9ab8e] py-1 px-2 rounded-[3px]">
                  <p className="text-xs text-[#785042] font-bold">
                    Software Developer
                  </p>
                </div>
                <div className="relative h-0.5 w-[70%] bg-black my-5"></div>
              </div>

              <div className="flex flex-col gap-1">
                <div className="flex items-center gap-5 w-[70%]  m-auto mt-5 ">
                  <div className=" text-xs flex items-center justify-center">
                    <FaEnvelope className="text-lg text-gray-600" />
                  </div>
                  <div className="flex flex-col text-xs text-black">
                    <a
                      href="mailto:mandlambolekwa@gmail.com"
                      target="_blank"
                      className="transition-all 0.5s ease-in-out hover:text-[#5432b8] cursor-pointer rounded-lg py-1  flex flex-col justify-center items-center border-black"
                    >
                      <p>mandlambolekwa@gmail.com</p>
                    </a>
                  </div>
                  <div className=" text-xs text-[#c78d41] flex items-center justify-center">
                    <FaExternalLinkAlt />
                  </div>
                </div>
                <div className="flex items-center gap-5 w-[70%]  m-auto mt-5">
                  <div className="text-xs flex items-center justify-center">
                    <FaMapMarkerAlt className="text-lg text-gray-600" />
                  </div>
                  <div className="flex flex-col text-xs text-black">
                    <p>Gauteng, Johannesburg</p>
                  </div>
                </div>
              </div>
              <div className=" flex justify-center pt-5 ">
                <a
                  href="https://github.com/23Mandla"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2 flex items-center justify-center rounded-full hover:scale-110 transition-all"
                >
                  <FaGithub className="text-xl rounded-md text-gray-600" />
                </a>
                <a
                  href="https://www.linkedin.com/in/mandla-mbolekwa-a2501320a/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2 flex items-center justify-center rounded-md cursor-pointer  hover:scale-110 transition-all"
                >
                  <FaLinkedin className="text-xl rounded-md text-gray-600" />
                </a>
              </div>
            </div>
          </div>
        </div>
        {/*main work summary */}
        <div className="flex items-center flex-col pt-8 md:pt-16 gap-3 col-span-2 md:pr-3">
          <div
            className="bg-[#C4A484] rounded-lg pb-[20rem] md:pb-[28.5rem] relative"
            style={{
              backgroundImage: `url(${activeBackground})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              transition: "all 0.9s ease-out",
            }}
          >
            <div className="absolute inset-0 bg-black/50 rounded-lg z-0" />
            <div
              className="md:hidden h-[10px] w-full abosolute rounded-full shadow-2xl"
              style={{ backgroundColor: "rgba(0,0,0,0.8)" }}
            >
              <div
                key={activeBackground}
                className="h-full rounded-full"
                style={{
                  backgroundColor: "#F0DC82",
                  animation: `fillBar ${slide_delay}ms linear forwards`,
                }}
              />
            </div>

            <div className="grid grid-cols-2 translate-y-[18rem]  md:translate-y-[25rem]">
              <div className="hidden md:grid translate-y-6 items-end ">
                <div className="flex items-center justify-center gap-8">
                  <div
                    className="border border-[#4e4e50] shadow-2xl cursor-pointer w-16 h-16 flex items-center justify-center  rounded-full"
                    style={{ backgroundColor: "rgba(0,0,0,0.3)" }}
                    onClick={() => swiperRef.current?.slidePrev()}
                  >
                    <FaAngleLeft />
                  </div>
                  <div
                    className="border border-[#4e4e50] shadow-2xl cursor-pointer w-16 h-16 flex items-center justify-center rounded-full"
                    style={{ backgroundColor: "rgba(0,0,0,0.3)" }}
                    onClick={() => swiperRef.current?.slideNext()}
                  >
                    <FaAngleRight />
                  </div>
                </div>

                <div
                  className="h-[1px] w-[70%] m-auto rounded-full shadow-2xl"
                  style={{ backgroundColor: "rgba(0,0,0,0.8)" }}
                >
                  <div
                    key={activeBackground}
                    className="h-full rounded-full"
                    style={{
                      backgroundColor: "#F0DC82",
                      animation: `fillBar ${slide_delay}ms linear forwards`,
                    }}
                  />
                </div>
              </div>
              <div className="col-span-2 md:col-auto pl-5">
                <Swiper
                  spaceBetween={20}
                  slidesPerView={2.6}
                  loop={true}
                  autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                  }}
                  scrollbar={{ draggable: true }}
                  modules={[Autoplay]}
                  onSwiper={(swiper) => (swiperRef.current = swiper)}
                  onSlideChange={(swiper) => {
                    setActiveBackground(slides[swiper.realIndex]);
                  }}
                  className="h-32 sm:h-40 fixed "
                >
                  {slides.map((image, index) => (
                    <SwiperSlide className="relative rounded-md" key={index}>
                      <img
                        src={image}
                        alt=""
                        className="w-full h-full object-fill shadow-2xl rounded-md"
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
